import {FeatureLaneDefinitionModel} from "data/models/feature-lane";

export const DELIVERABLES_FEATURE_LANE: FeatureLaneDefinitionModel[] = [
  {
    id: "canva-assets",
    title: "--",
    description: "--",
    userSurveys: [
      {
        id: "previews",
        title: "Previews",
        rules: {
          allowsAnonymous: false,
          dependsOn: [],
        },
      },
    ],
  },
];
